/* eslint-disable linebreak-style */
import {takeLatest, put, all, call} from 'redux-saga/effects';
import {
  SET_ORDERS_START,
} from './order.actions.types'
import {setOrdersSuccess} from './order.actions';
import {enqueueSnackbar, setLoading} from '../other/other.actions';
import {strapi, STRAPI_API_URL} from '../../strapi/strapi.config';
import {isFeatureEnabled} from '../../config/featureFlags';
import {fetchOrdersPageGraphql} from '../../strapi/graphql.orders';

const buildQueryString = (params = {})=>{
  const searchParams = new URLSearchParams();
  Object.keys(params).forEach((key)=>{
    const value = params[key];
    if (Array.isArray(value)) {
      value.forEach((arrayValue)=>{
        if (arrayValue !== null && arrayValue !== undefined && arrayValue !== '') {
          searchParams.append(key, String(arrayValue));
        }
      });
      return;
    }
    if (value !== null && value !== undefined && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  return searchParams.toString();
};

const getOrdersCountRestSafe = async (baseParams = {})=>{
  const queryString = buildQueryString(baseParams);
  const url = `${STRAPI_API_URL}/comandas/count${queryString ? `?${queryString}` : ''}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }
  const rawPayload = await response.text();
  const asNumber = Number(rawPayload);
  if (Number.isFinite(asNumber)) {
    return asNumber;
  }
  try {
    const parsed = JSON.parse(rawPayload);
    const parsedNumber = Number(parsed);
    return Number.isFinite(parsedNumber) ? parsedNumber : 0;
  } catch (parseError) {
    return 0;
  }
};


export function* getOrders({payload:{idFirma, idFirmeComisionar, isComisionar, tipProdus, subTip, filters = {}, page = 1, pageSize = 12, sort = 'id:desc'}}){
  const useServerPaging = isFeatureEnabled('ordersServerPaging')
  const useGraphqlRead = isFeatureEnabled('ordersGraphqlRead')
  try{
    if (!useServerPaging) {
      yield put(setLoading(true))
    }
    const isComisionarCuClienti = isComisionar === true && Array.isArray(idFirmeComisionar) && idFirmeComisionar.length > 0
    const safeFilters = filters && typeof filters === 'object' ? filters : {}
    let baseParams
    if (isComisionarCuClienti) {
      baseParams = subTip
        ? {...safeFilters, idFirma_in: idFirmeComisionar, tipProdus, subTip}
        : {...safeFilters, idFirma_in: idFirmeComisionar, tipProdus}
    } else {
      baseParams = subTip
        ? {...safeFilters, idFirma, tipProdus, subTip}
        : {...safeFilters, idFirma, tipProdus}
    }

    if (useServerPaging) {
      const pageNumber = Number(page) > 0 ? Number(page) : 1
      const limit = Number(pageSize) > 0 ? Number(pageSize) : 12
      const start = (pageNumber - 1) * limit
      if (useGraphqlRead) {
        try {
          const graphqlResult = yield call(fetchOrdersPageGraphql, {
            where: baseParams,
            start,
            limit,
            sort: sort || 'id:desc'
          })
          yield put(setOrdersSuccess({
            items: graphqlResult.items,
            pagination: {
              page: pageNumber,
              pageSize: limit,
              total: Number(graphqlResult.total || 0),
              serverPaging: true,
              sort: sort || 'id:desc'
            }
          }))
          return
        } catch (graphqlError) {
          console.warn('[ordersGraphqlRead][fallback] reason=graphql-list-error', graphqlError)
        }
      }
      const params = {
        ...baseParams,
        _start: start,
        _limit: limit,
        _sort: sort || 'id:desc'
      }
      const orders = yield strapi.getEntries('comandas', params)
      const total = yield call(getOrdersCountRestSafe, baseParams)
      yield put(setOrdersSuccess({
        items: orders,
        pagination: {
          page: pageNumber,
          pageSize: limit,
          total: Number(total || 0),
          serverPaging: true,
          sort: sort || 'id:desc'
        }
      }))
    } else {
      const params = {
        ...baseParams,
        _limit: -1
      }
      const orders = yield strapi.getEntries('comandas', params)
      yield put(setOrdersSuccess({
        items: orders,
        pagination: {
          page: 1,
          pageSize: orders.length || 12,
          total: orders.length || 0,
          serverPaging: false,
          sort: sort || 'id:desc'
        }
      }))
    }
    if (!useServerPaging) {
      yield put(setLoading(false))
    }
  }catch(error){ 
    if (!useServerPaging) {
      yield put(setLoading(false))
    }
    yield put(enqueueSnackbar({
      message: `Eroare: nu am putut prelua lista de comenzi.(${error})`,
      options: {
        key: null,
        variant: 'error',
        persist:true,  
      },
    },5000))
  }
}


export function* onSetOrdersStart(){
  yield takeLatest (SET_ORDERS_START,getOrders)
}


export function* orderSagas(){
  yield all([
    call(onSetOrdersStart),
  ])
}
